<template>
    <div class="container">
        <v-form :valid="valid">
            <v-text-field
                label="Name"
                v-model="formValue.name">
            </v-text-field>
            <json-form-editor v-model="formValue.schema" @formModelChange="(value) => formValue.template = value"></json-form-editor>
            <v-text-field
                label="JS"
                v-model="formValue.js">
                >
            </v-text-field>
            <v-text-field
                label="CSS"
                v-model="formValue.css">
                >
            </v-text-field>
            <v-text-field
                label="Object"
                v-model="formValue.object">
            </v-text-field>
            <v-slider
                label="Order"
                thumb-label="always"
                :min="0"
                :max="100"
                v-model="formValue.order">
                >
            </v-slider>
            <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="submitForm"
                >
                Submit
            </v-btn>
        </v-form>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() {
                return {
                    name: "",
                    order: 0,
                    js: '',
                    css: '',
                    object: 0,
                    schema: {
                        "type": "object",
                        "properties": {
                            "stringProp": {
                                "type": "string",
                                "title": "I\'m a string",
                                "description": "This description is used as a help message."
                            },
                            "stringTextareaProp": {
                                "type": "string",
                                "title": "I\'m a string in a textarea",
                                "x-display": "textarea"
                            } 
                        }
                    },   
                }
            }
        }
    },
    data() {
        return {
            valid: true,
            formValue: this.value
        }
    },
    methods: {
        submitForm: function() {
            const fillEmptyFields = (template) => {
                const { schema } = this.formValue;

                Object.keys(schema.properties).forEach(key => {
                    if (!template[key]) {
                        template[key] = '';
                    }
                });

                return template;
            }

            this.formValue.template = JSON.stringify(fillEmptyFields(this.formValue.template));
            this.$emit('submit', this.formValue);
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/forms/JSONSchemaForm.vue